module.exports = __webpack_public_path__ + "img/logo.1e03a4fd.png";